import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthModule } from "./auth/auth.module";
import { MaterialModule } from "./material/material.module";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MainModule } from "./main/main.module";
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { AlmacenMenajeriaModule } from "./almacen-menajeria/almacen-menajeria.module";
import { LoadingInterceptorService } from "./services/interceptors/loading-interceptor.service";
import { MatIconModule } from '@angular/material/icon';
import { AuthInterceptor } from './services/interceptors/auth.interceptor';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { AlmacenEquiposModule } from './almacen-equipos/almacen-equipos.module';
import { CallbackComponent } from './callback/callback.component';

@NgModule({
  declarations: [
    AppComponent,
    CallbackComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AuthModule,
    AlmacenEquiposModule,
    AlmacenMenajeriaModule,
    MaterialModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MainModule,
    MatIconModule,
    SweetAlert2Module.forRoot()

  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB'
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
